import { getStorage, ref, getDownloadURL } from "firebase/storage";
import {
  getDatabase,
  onValue,
  update,
  set,
  child,
  push,
  ref as ref_database,
} from "firebase/database";
import firebase from "../../firebase/config";
import { setAnalysisData } from "./analysisActions";
import { v4 as uuid } from "uuid";

export const fetchFlowTypeMeta = (type) => {
  return async (dispatch, getState, { getFirebase }) => {
    if (type) {
      // RESOLVE CORSE ERROR (authorize local hots on gcloud) : https://stackoverflow.com/questions/37760695/firebase-storage-and-access-control-allow-origin
      const storage = getFirebase().storage();
      const pathReference = ref(storage, "meta_data/flows/" + type + ".json");
      await getDownloadURL(pathReference).then((url) => {
        fetch(url)
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            dispatch({ type: "FETCH_FLOW_TYPE_META", payload: json });
          })
          .catch((error) => console.error(error));
      });
    } else {
      dispatch({ type: "FETCH_FLOW_TYPE_META", payload: "" });
    }
  };
};

export const setFlowTypeMeta = (type) => {
  return async (dispatch, getState, { getFirebase }) => {
    dispatch({ type: "SET_FLOW_TYPE_META", payload: "" });
  };
};


const getNowTime = () => {
  const server_time = firebase.firestore.Timestamp.now();
  const now_time = new Date(
    server_time.seconds * 1000 + server_time.nanoseconds / 1000000
  );
  return now_time.toLocaleString();
};



// export const addFlowToStepRemote = (item) => {
//   return async (dispatch, getState, { getFirebase }) => {
//     const database = getDatabase();
//     // get analysis data
//     const state = getState();
//     const analysis_data = state.analysis.analysis_data;

//     // IF IS INGREDIENTS
//     // let newIngredientKey;
//     if (item.step_index === 4) {
//       // get new path id
//       const newIngredientKey = push(
//         child(
//           ref_database(database),
//           `analysis/${item.analysis_id}/ingredients/`
//         )
//       ).key;
//       // get ingredient data to write
//       const storage = getFirebase().storage();
//       const pathReference = ref(
//         storage,
//         "ingredients/" + item.flow_meta.id + ".json"
//       );
//       await getDownloadURL(pathReference).then((url) => {
//         fetch(url)
//           .then((response) => {
//             return response.json();
//           })
//           .then((json) => {
//             // update local ingredients
//             analysis_data["ingredients"] = {
//               ...analysis_data["ingredients"],
//               [newIngredientKey]: json,
//             };
//             // update local lca_steps
//             //// find K_Ingredients
//             const ingredient = json.filter(
//               (x) => x.category.name === "K_Ingredients"
//             )[0];
//             //// create data model
//             const data = {
//               amount: ingredient["outputs"][0]["amount"], // default value
//               description: ingredient["outputs"][0]["flow"]["description"],
//               flow: ingredient["outputs"][0]["flow"],
//               id: uuid(), // ingredient['outputs'][0]['id'],
//               input: true,
//               is_agricultural: ingredient["outputs"][0]["is_agricultural"],
//               process_id: uuid(),
//               quantitative_reference:
//                 ingredient["outputs"][0]["quantitative_reference"],
//               unit: ingredient["outputs"][0]["unit"],
//               updatedAt: getNowTime(),
//               updated_by: "user",
//               __typename: "Exchange",
//             };
//             // update
//             analysis_data["lca"]["lca_steps"][item.step_index]["inputs"].push(
//               data
//             );
//             setAnalysisData(analysis_data);

//             // update remote lca_steps
//             set(
//               ref_database(
//                 database,
//                 `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${newIngredientKey}`
//               ),
//               data
//             );
//             // update remote ingredients
//             set(
//               ref_database(
//                 database,
//                 `analysis/${item.analysis_id}/ingredients/${newIngredientKey}`
//               ),
//               json
//             );
//           })
//           .catch((error) => console.error(error));
//       });

//       // IF IS NOT INGREDIENTS
//     } else {
//       // get new path id
//       const newFlowKey = push(
//         child(
//           ref_database(database),
//           `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/`
//         )
//       ).key;
//       // get ingredient data to write
//       const storage = getFirebase().storage();
//       const pathReference = ref(
//         storage,
//         "flows/" + item.flow_meta.id + ".json"
//       );
//       await getDownloadURL(pathReference).then((url) => {
//         fetch(url)
//           .then((response) => {
//             return response.json();
//           })
//           .then((json) => {
//             const data = {
//               amount: 0.03, // ask user to set this value
//               description: json["description"],
//               flow: json,
//               id: json["id"], // gen ID
//               input: true,
//               is_agricultural: false,
//               process_id: uuid(), // same as other inputs
//               quantitative_reference: false,
//               unit: json.unit,
//               updatedAt: getNowTime(), // firebase.firestore.Timestamp.now(),
//               updated_by: "user",
//               __typename: "Exchange",
//             };
//             // update local data
//             analysis_data["lca"]["lca_steps"][item.step_index]["inputs"].push(
//               data
//             );
//             setAnalysisData(analysis_data);
//             // update remote data
//             set(
//               ref_database(
//                 database,
//                 `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${newFlowKey}`
//               ),
//               data
//             );
//           })
//           .catch((error) => console.error(error));
//       });
//     }
//     dispatch({ type: "ADD_FLOW_TO_STEP_REMOTE" });
//   };
// };

// export const updateOriginQuantity = (item) => {
//     return async (dispatch, getState, { getFirebase }) => {
//         const database = getDatabase();
//         // get analysis data
//         const state = getState();
//         const analysis_data = state.analysis.analysis_data;

//         // update local amount
//         // get id of raw materials
//         const raw_id = analysis_data['ingredients'][item.flow_id].find(x => x.category.name === "K_Raw_Materials").id
//         // get index of raw_id
//         const index_raw_id = analysis_data['ingredients'][item.flow_id].findIndex(x => x.id === raw_id)
//         // update data locally
//         analysis_data['ingredients'][item.flow_id][index_raw_id]['inputs'][item.index_origin]['amount'] = parseFloat(item.value)
//         setAnalysisData(analysis_data)

//         // console.log("ANALYSIS::", item['ingredients'][])
//         // TODO update remote

//         // setAnalysisData(analysis_data)

//         // local update
//         // console.log("analysis_data: ", analysis_data)

//         dispatch({ type: "UPDATE_ORIGIN" });
//     };
// };
